import type { SupabaseClient } from '@supabase/supabase-js'
import type { AppSupabaseClient } from '@/infrastructure/supabase/client'
import { DemandesV3Error, type DemandesV3Repository } from '../application/DemandesV3Repository'
import { demandesTriageSchema } from '../domain/leadCategory'

interface RpcResponse {
  data: unknown
  error: { message: string } | null
}

function rpcErrorCode(message: string): string {
  return /LEAD(_CATEGORY)?_[A-Z_]+/.exec(message)?.[0] ?? 'UNEXPECTED'
}

/** Aucun repli sur des fixtures : un faux classement se lirait comme le vrai. */
export function createSupabaseDemandesV3Repository(client: AppSupabaseClient): DemandesV3Repository {
  const rpcClient = client as unknown as SupabaseClient

  async function call(name: string, args?: Record<string, unknown>): Promise<unknown> {
    let response: RpcResponse
    try {
      response = await rpcClient.rpc(name, args)
    } catch {
      throw new DemandesV3Error('NETWORK')
    }
    if (response.error) throw new DemandesV3Error(rpcErrorCode(response.error.message))
    return response.data
  }

  const command = async (name: string, payload: object) => {
    await call(name, { p_command: payload })
  }

  return {
    async getTriage() {
      const parsed = demandesTriageSchema.safeParse(await call('demandes_v3_triage_v1'))
      if (!parsed.success) throw new DemandesV3Error('RESPONSE_INVALID')
      return parsed.data
    },
    createCategory: (payload) => command('create_lead_category_v1', payload),
    updateCategory: (payload) => command('update_lead_category_v1', payload),
    setCategoryArchived: (payload) => command('set_lead_category_archived_v1', payload),
    reorderCategories: (categoryIds) => command('reorder_lead_categories_v1', { categoryIds }),
    assignCategory: (payload) => command('assign_lead_category_v1', payload),
    restoreLead: (leadId) => command('restore_lead_v1', { leadId }),
  }
}
